const getters = {
  errorLogs: state => state.errorLog.logs,
  currentPayType: state => state.rechare.currentPayType,
  payTypeName: state => state.rechare.payTypeName,
  agentSubuserList: state => state.agent.subuserList,
  systemMaintenanceInfo: state => state.systemMaintenanceInfo
};
export default getters;
